/*
 * @file: index.js
 * @description: It Contain user related Action Creators.
 * @author: navreet
 */

import * as TYPE from '../constants'
import ApiClient from '../../api-client'
import { apiUrl, apiUrlBase, apiUrlMerchantItems, apiUrlSchool, apiUrlVehicle } from '../../environment'

export const is_fetching = (status) => ({ type: TYPE.IS_FETCHING, status })

export const logout_user = () => ({ type: TYPE.LOG_OUT })
export const schools = (data, res) => ({ type: TYPE.SETTINGS, data, res })
export const vehicles = (data, res) => ({ type: TYPE.SETTINGS, data, res })
export const socialMedia = (data) => ({ type: TYPE.SOCIAL_MEDIA, data })
export const routeMap = (data) => ({ type: TYPE.ROUTE_MAP, data })
export const errorUpdate = (data, message) => ({
    type: TYPE.ERROR_STATUS,
    data,
    message,
})
export const faq = (data, res) => ({ type: TYPE.FAQ_LIST, data, res })

export const rewards = (data) => ({ type: TYPE.REWARD, data })

export const adminPageInfo = (data, res) => ({ type: TYPE.ADMIN_PAGE_INFO, data, res })

export const schoolList = (params, callback) => {
    return (dispatch, getState) => {
        const { token } = getState().user
        dispatch(is_fetching(true))
        ApiClient.get(`${apiUrlSchool}/getSchool`, params, token).then((response) => {
            if (response.customcode === 200) {
                dispatch(is_fetching(false))
                dispatch(schools(response.data, response))
                // toastAction(true, response.message);
                callback(true)
            } else if (response.customcode === 401) {
                dispatch(logout_user())
                dispatch(is_fetching(false))

                callback(false)
            } else {
                dispatch(is_fetching(false))
                dispatch(errorUpdate(true, response.message))
                callback(false)
            }
        })
    }
}
export const vehicleList = (params, callback) => {
    return (dispatch, getState) => {
        const { token } = getState().user
        dispatch(is_fetching(true))
        ApiClient.get(`${apiUrlVehicle}/getVehicle`, params, token).then((response) => {
            if (response.customcode === 200) {
                dispatch(is_fetching(false))
                dispatch(vehicles(response.data, response))
                // toastAction(true, response.message);
                callback(true)
            } else if (response.customcode === 401) {
                dispatch(logout_user())
                dispatch(is_fetching(false))

                callback(false)
            } else {
                dispatch(is_fetching(false))
                dispatch(errorUpdate(true, response.message))
                callback(false)
            }
        })
    }
}

export const getSocialMedia = (params, callback) => {
    return (dispatch, getState) => {
        const { token } = getState().user
        dispatch(is_fetching(true))
        ApiClient.get(`${apiUrlBase}/social/get-post-template`, params, token).then((response) => {
            if (response.customcode === 200) {
                dispatch(is_fetching(false))
                dispatch(socialMedia(response.data))
                // toastAction(true, response.message);
                callback(true)
            } else if (response.customcode === 401) {
                dispatch(logout_user())
                dispatch(is_fetching(false))
                callback(false)
            } else {
                dispatch(is_fetching(false))
                dispatch(errorUpdate(true, response.message))
                callback(false)
            }
        })
    }
}

/****** action creator to get Reward ********/
export const getRewards = (params, callback) => {
    return (dispatch, getState) => {
        const { token } = getState().user
        dispatch(is_fetching(true))
        ApiClient.get(`${apiUrlBase}/info/rewards`, params, token).then((response) => {
            if (response.customcode === 200) {
                dispatch(is_fetching(false))
                dispatch(rewards(response.data))
                callback(true)
            } else if (response.customcode === 401) {
                dispatch(logout_user())
                dispatch(is_fetching(false))
                callback(false)
            } else {
                dispatch(is_fetching(false))
                dispatch(errorUpdate(true, response.message))
                callback(true)
            }
        })
    }
}
/****** action creator to manage Reward ********/
export const updateReward = (params, callback) => {
    return (dispatch, getState) => {
        const { token } = getState().user
        dispatch(is_fetching(true))
        ApiClient.put(`${apiUrlBase}/info/update-rewards`, params, token).then((response) => {
            if (response.customcode === 200) {
                dispatch(is_fetching(false))
                callback(true)
            } else if (response.customcode === 401) {
                dispatch(logout_user())
                dispatch(is_fetching(false))
                callback(false)
            } else {
                dispatch(is_fetching(false))
                dispatch(errorUpdate(true, response.message))
                callback(true)
            }
        })
    }
}
/****** action creator get adminPageInfo ********/
export const getAdminPageInfo = (params, callback) => {
    return (dispatch, getState) => {
        const { token } = getState().user
        dispatch(is_fetching(true))
        ApiClient.get(`${apiUrlBase}/info/adminPageInfo`, params, token).then((response) => {
            if (response.customcode === 200) {
                dispatch(is_fetching(false))
                dispatch(adminPageInfo(response.data))
                callback(true)
            } else if (response.customcode === 401) {
                dispatch(logout_user())
                dispatch(is_fetching(false))
                callback(false)
            } else {
                dispatch(is_fetching(false))
                dispatch(errorUpdate(true, response.message))
                callback(true)
            }
        })
    }
}
/****** action creator to update terms use ********/
export const updateTerms = (params, callback) => {
    return (dispatch, getState) => {
        const { token } = getState().user
        dispatch(is_fetching(true))
        ApiClient.put(`${apiUrlBase}/info/update-terms-use`, params, token).then((response) => {
            if (response.customcode === 200) {
                dispatch(is_fetching(false))
                callback(true)
            } else if (response.customcode === 401) {
                dispatch(logout_user())
                dispatch(is_fetching(false))
                callback(false)
            } else {
                dispatch(is_fetching(false))
                dispatch(errorUpdate(true, response.message))
                callback(true)
            }
        })
    }
}
/****** action creator to update privacy policy********/
export const updatePrivacy = (params, callback) => {
    return (dispatch, getState) => {
        const { token } = getState().user
        dispatch(is_fetching(true))
        ApiClient.put(`${apiUrlBase}/info/update-privacy-policy`, params, token).then((response) => {
            if (response.customcode === 200) {
                dispatch(is_fetching(false))
                callback(true)
            } else if (response.customcode === 401) {
                dispatch(logout_user())
                dispatch(is_fetching(false))
                callback(false)
            } else {
                dispatch(is_fetching(false))
                dispatch(errorUpdate(true, response.message))
                callback(true)
            }
        })
    }
}
/****** action creator to update license agreement********/
export const updateLicense = (params, callback) => {
    return (dispatch, getState) => {
        const { token } = getState().user
        dispatch(is_fetching(true))
        ApiClient.put(`${apiUrlBase}/info/update-license-agreement`, params, token).then((response) => {
            if (response.customcode === 200) {
                dispatch(is_fetching(false))
                callback(true)
            } else if (response.customcode === 401) {
                dispatch(logout_user())
                dispatch(is_fetching(false))
                callback(false)
            } else {
                dispatch(is_fetching(false))
                dispatch(errorUpdate(true, response.message))
                callback(true)
            }
        })
    }
}

/****** action creator for delete User ********/
export const deleteSchool = (params, callback) => {
    return (dispatch, getState) => {
        const { token } = getState().user
        dispatch(is_fetching(true))
        ApiClient.delete(`${apiUrlSchool}/${params.id}`, params, token).then((response) => {
            if (response.customcode === 200) {
                dispatch(is_fetching(false))
                callback(true)
            } else if (response.customcode === 401) {
                dispatch(logout_user())
                dispatch(is_fetching(false))

                callback(false)
            } else {
                dispatch(is_fetching(false))
                dispatch(errorUpdate(true, response.message))
                callback(true)
            }
        })
    }
}


/****** action creator for delete User ********/
export const deleteFaq = (params, callback) => {
    return (dispatch, getState) => {
        const { token } = getState().user
        dispatch(is_fetching(true))
        ApiClient.delete(`${apiUrlBase}/faq/${params.id}`, params, token).then((response) => {
            if (response.customcode === 200) {
                dispatch(is_fetching(false))
                callback(true)
            } else if (response.customcode === 401) {
                dispatch(logout_user())
                dispatch(is_fetching(false))

                callback(false)
            } else {
                dispatch(is_fetching(false))
                dispatch(errorUpdate(true, response.message))
                callback(true)
            }
        })
    }
}
/****** action creator for delete User ********/
export const deleteVehicle = (params, callback) => {
    return (dispatch, getState) => {
        const { token } = getState().user
        dispatch(is_fetching(true))
        ApiClient.delete(`${apiUrlVehicle}/${params.id}`, params, token).then((response) => {
            if (response.customcode === 200) {
                dispatch(is_fetching(false))
                callback(true)
            } else if (response.customcode === 401) {
                dispatch(logout_user())
                dispatch(is_fetching(false))

                callback(false)
            } else {
                dispatch(is_fetching(false))
                dispatch(errorUpdate(true, response.message))
                callback(true)
            }
        })
    }
}

export const faqList = (params, callback) => {
    return (dispatch, getState) => {
        const { token } = getState().user
        dispatch(is_fetching(true))
        ApiClient.get(`${apiUrlBase}/faq/getFaq`, params, token).then((response) => {
            if (response.customcode === 200) {
                dispatch(is_fetching(false))
                dispatch(faq(response.data, response))
                // toastAction(true, response.message);
                callback(true)
            } else if (response.customcode === 401) {
                dispatch(logout_user())
                dispatch(is_fetching(false))

                callback(false)
            } else {
                dispatch(is_fetching(false))
                dispatch(errorUpdate(true, response.message))
                callback(false)
            }
        })
    }
}

/****** action creator for add User ********/
export const addSchool = (params, callback) => {
    return (dispatch, getState) => {
        const { token } = getState().user
        dispatch(is_fetching(true))
        ApiClient.post(`${apiUrlSchool}/create`, params, token).then((response) => {
            if (response.customcode === 200) {
                dispatch(is_fetching(false))
                callback(true)
            } else if (response.customcode === 401) {
                dispatch(logout_user())
                dispatch(is_fetching(false))

                callback(false)
            } else {
                dispatch(is_fetching(false))
                dispatch(errorUpdate(true, response.message))
                callback(true)
            }
        })
    }
}

/****** action creator for add User ********/
export const addVehicle = (params, callback) => {
    return (dispatch, getState) => {
        const { token } = getState().user
        dispatch(is_fetching(true))
        ApiClient.post(`${apiUrlVehicle}/create`, params, token).then((response) => {
            if (response.customcode === 200) {
                dispatch(is_fetching(false))
                callback(true)
            } else if (response.customcode === 401) {
                dispatch(logout_user())
                dispatch(is_fetching(false))

                callback(false)
            } else {
                dispatch(is_fetching(false))
                dispatch(errorUpdate(true, response.message))
                callback(true)
            }
        })
    }
}

/****** action creator for add User ********/
export const addFaq = (params, callback) => {
    return (dispatch, getState) => {
        const { token } = getState().user
        dispatch(is_fetching(true))
        ApiClient.post(`${apiUrlBase}/faq/create`, params, token).then((response) => {
            if (response.customcode === 200) {
                dispatch(is_fetching(false))
                callback(true)
            } else if (response.customcode === 401) {
                dispatch(logout_user())
                dispatch(is_fetching(false))

                callback(false)
            } else {
                dispatch(is_fetching(false))
                dispatch(errorUpdate(true, response.message))
                callback(true)
            }
        })
    }
}

/****** action creator for edit User ********/
export const editSchool = (params, callback) => {
    return (dispatch, getState) => {
        const { token } = getState().user
        dispatch(is_fetching(true))
        ApiClient.put(`${apiUrlSchool}//${params.id}`, params, token).then((response) => {
            if (response.customcode === 200) {
                dispatch(is_fetching(false))
                callback(true)
            } else if (response.customcode === 401) {
                dispatch(logout_user())
                dispatch(is_fetching(false))

                callback(false)
            } else {
                dispatch(is_fetching(false))
                dispatch(errorUpdate(true, response.message))
                callback(true)
            }
        })
    }
}



/****** action creator for edit User ********/
export const editFaq = (params, callback) => {
    return (dispatch, getState) => {
        const { token } = getState().user
        dispatch(is_fetching(true))
        ApiClient.put(`${apiUrlBase}/faq/${params.id}`, params, token).then((response) => {
            if (response.customcode === 200) {
                dispatch(is_fetching(false))
                callback(true)
            } else if (response.customcode === 401) {
                dispatch(logout_user())
                dispatch(is_fetching(false))

                callback(false)
            } else {
                dispatch(is_fetching(false))
                dispatch(errorUpdate(true, response.message))
                callback(true)
            }
        })
    }
}

/****** action creator for edit User ********/
export const editSocialMedia = (params, callback) => {
    return (dispatch, getState) => {
        const { token } = getState().user
        dispatch(is_fetching(true))
        ApiClient.put(`${apiUrlBase}/social/update-post-template`, params, token).then((response) => {
            if (response.customcode === 200) {
                dispatch(is_fetching(false))
                callback(true)
            } else if (response.customcode === 401) {
                dispatch(logout_user())
                dispatch(is_fetching(false))

                callback(false)
            } else {
                dispatch(is_fetching(false))
                dispatch(errorUpdate(true, response.message))
                callback(true)
            }
        })
    }
}

/****** action creator for edit User ********/
export const editAppContent = (params, callback) => {
    return (dispatch, getState) => {
        const { token } = getState().user
        dispatch(is_fetching(true))
        ApiClient.put(`${apiUrlBase}/social/update-home-page`, params, token).then((response) => {
            if (response.customcode === 200) {
                dispatch(is_fetching(false))
                callback(true)
            } else if (response.customcode === 401) {
                dispatch(logout_user())
                dispatch(is_fetching(false))

                callback(false)
            } else {
                dispatch(is_fetching(false))
                dispatch(errorUpdate(true, response.message))
                callback(true)
            }
        })
    }
}
/****** action creator for edit User ********/
export const editVehicle = (params, callback) => {
    return (dispatch, getState) => {
        const { token } = getState().user
        dispatch(is_fetching(true))
        ApiClient.put(`${apiUrlVehicle}/${params.id}`, params, token).then((response) => {
            if (response.customcode === 200) {
                dispatch(is_fetching(false))
                callback(true)
            } else if (response.customcode === 401) {
                dispatch(logout_user())
                dispatch(is_fetching(false))

                callback(false)
            } else {
                dispatch(is_fetching(false))
                dispatch(errorUpdate(true, response.message))
                callback(true)
            }
        })
    }
}

export const routeMapGet = (params, callback) => {
    return (dispatch, getState) => {
        const { token } = getState().user
        dispatch(is_fetching(true))
        ApiClient.get(`${apiUrlBase}/route/getRouteMap`, params, token).then((response) => {
            if (response.customcode === 200) {
                dispatch(is_fetching(false))
                dispatch(routeMap(response.data))
                // toastAction(true, response.message);
                callback(true)
            } else if (response.customcode === 401) {
                dispatch(logout_user())
                dispatch(is_fetching(false))

                callback(false)
            } else {
                dispatch(is_fetching(false))
                dispatch(errorUpdate(true, response.message))
                callback(false)
            }
        })
    }
}
export const updateRouteMap = (params, callback) => {
    return (dispatch, getState) => {
        const { token } = getState().user
        dispatch(is_fetching(true))
        ApiClient.put(`${apiUrlBase}/route/updateRouteMap`, params, token).then((response) => {
            if (response.customcode === 200) {
                dispatch(is_fetching(false))
                callback(true)
            } else if (response.customcode === 401) {
                dispatch(logout_user())
                dispatch(is_fetching(false))

                callback(false)
            } else {
                dispatch(is_fetching(false))
                dispatch(errorUpdate(true, response.message))
                callback(true)
            }
        })
    }
}

/****** action creator for logout ********/
export const logout = (token, callback) => {
    return (dispatch) => {
        //dispatch(is_fetching(true));
        //ApiClient.delete(`${apiUrl}/user/logout`, token).then(response => {
        //  if (response.statusCode === 200) {
        //    dispatch(is_fetching(false));
        dispatch(logout_user())
        callback(true)
        //  } else {
        //    dispatch(is_fetching(false));
        //    toastAction(false, response.msg);
        //    callback(true);
        //  }
        //});
    }
}
